import { useQuery } from '@tanstack/react-query';

import { riskRangeApi } from '../api/risk-range.adapter';

export const riskRangeQueryKeys = {
  all: ['risk-range'] as const,
  range: () => [...riskRangeQueryKeys.all, 'range'] as const,
};

export function useRiskRangeQuery() {
  return useQuery({
    queryKey: riskRangeQueryKeys.range(),
    queryFn: () => riskRangeApi.getRange(),
  });
}
